import { graphql } from '../graphql';

export const layerByproductsQuery = graphql(`
  query LayerByproducts($layerId: ID!) {
    layerByproducts(layerId: $layerId) {
      id
      filename
      type
      contentLength
      downloadUrl
      processJobId
      createdAt
    }
  }
`);

/**
 * Byproducts of a (synthetic ANALYSIS) batch, resolved by batchId — works for
 * download-only exports whose source layer has no sourceAttachmentId (e.g.
 * vector sublayers), where layerByproducts returns nothing. This is the same
 * batchId-keyed resolver the analysis-batch panel uses. `type` is omitted so
 * the download path doesn't depend on the ByproductType enum being redeployed.
 */
export const batchByproductsQuery = graphql(`
  query BatchByproducts($id: ID!) {
    batch(id: $id) {
      id
      byproducts {
        id
        filename
        downloadUrl
        processJobId
      }
    }
  }
`);
